var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u7EC4_7831",
    "data-name": "\\u7EC4 7831",
    transform: "translate(-796 -521)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_4822",
    "data-name": "\\u8DEF\\u5F84 4822",
    d: "M65,190v-4a3,3,0,0,1,3-3h6a3,3,0,0,1,3,3v4Zm6-11a3,3,0,1,1,3-3A3,3,0,0,1,71,179Z",
    transform: "translate(735 349)",
    fill: "rgba(153,153,153,0.2)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_4823",
    "data-name": "\\u8DEF\\u5F84 4823",
    d: "M74,190v-4a3,3,0,0,0-3-3H65a3,3,0,0,0-3,3v4H61v-5a3,3,0,0,1,3-3h8a3,3,0,0,1,3,3v5Zm-6-10a4,4,0,1,1,4-4A4,4,0,0,1,68,180Zm0-7a3,3,0,1,0,3,3A3,3,0,0,0,68,173Z",
    transform: "translate(735 349)",
    fill: "#999",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg);
export default __webpack_public_path__ + "static/media/姓名.2ad6297afe94e5da6233025fadce03ed.svg";
export { ForwardRef as ReactComponent };